// -----------------------------------------------------------------------------
// Library
// -----------------------------------------------------------------------------
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

// -----------------------------------------------------------------------------
// Store
// -----------------------------------------------------------------------------
import { selectSelectedWorkout } from "store/selectors";

// -----------------------------------------------------------------------------
// Components
// -----------------------------------------------------------------------------
import { Button } from "components/Common/Button";
import { GenreSelector } from "components/Common/GenreSelector";
// -----------------------------------------------------------------------------
// Utils and Styles
// -----------------------------------------------------------------------------
import StyledWorkoutMusicForm from "./styles";
import { useGetDomainGymQuery } from "store/api/api";
import { useParams } from "react-router";
import { Flex } from "antd";

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------
const WorkoutMusicForm = ({ nextStep, live, previousStep, values, loading, maxWidth }) => {
	const [selectedGenre, setSelectedGenre] = useState({
		title: values?.music_genre,
		id: values?.playlist_id,
	});
	const [isDisabledSaveBtn, setDisabledSaveBtn] = useState(false);
	const selectedWorkout = useSelector(selectSelectedWorkout);
	const { gym } = useParams();
	const domainGymResponse = useGetDomainGymQuery(gym);
	const domainGymId = domainGymResponse.data?.id;
	const getPayload = () => {
		let payload;
		if (selectedGenre) {
			const { title, id } = selectedGenre;
			payload = {
				workout_id: selectedWorkout?.id,
				gym_id: domainGymId,
				music_genre: title,
				playlist_id: id,
			};
		}
		return payload;
	};

	const onSave = () => {
		const payload = getPayload();
		nextStep(payload);
	};

	const onPrevious = () => {
		const payload = getPayload();
		previousStep(payload);
	};

	useEffect(() => {
		let timer;
		if (loading) {
			setDisabledSaveBtn(true);
			timer = setTimeout(() => {
				setDisabledSaveBtn(false);
			}, 1000);
		}
		return clearTimeout(timer);
	}, 
	[loading]);

	return (
		<StyledWorkoutMusicForm>
			<div style={{ maxWidth }} className="sb-workout-music-form">
				<GenreSelector initialSelectedGenreId={values.playlist_id} setSelectedGenre={setSelectedGenre} />
			</div>
			<Flex className="sb-workout-music-form__actions">
				<Button
					style={{ flex: 1, maxWidth: "unset" }}
					type="button"
					onClick={onPrevious}
					className="cancel-btn"
					data-id="btnBack"
				>
					Previous
				</Button>
				<Button
					data-id="btnSave"
					type="button"
					className="primary-filled"
					onClick={onSave}
					loading={isDisabledSaveBtn}
					disabled={isDisabledSaveBtn}
					style={{ flex: 1, maxWidth: "unset" }}
				>
					{live ? "Next" : "Save"}
				</Button>
			</Flex>
		</StyledWorkoutMusicForm>
	);
};

export default WorkoutMusicForm;

